import { useState, useCallback } from 'react';

const PAGE_SIZE = 12;

export const useGetDrops = (issueId) => {
  const [drops, setDrops] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [error, setError] = useState(null);

  const fetchDrops = useCallback(async (skip = 0) => {
    if (!issueId) return;
    
    setIsLoading(true);

    try {
      const response = await fetch(`/api/getEntries`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          content_type: 'drop',
          order: '-fields.dropDate',
          limit: PAGE_SIZE,
          skip: skip,
          options: { 
            links_to_entry: issueId,
            select: ['fields.title', 'fields.cover']
          },
        }),
      });
      
      const data = await response.json();
      
      if (skip === 0) {
        setDrops(data);
      } else {
        setDrops(prev => [...prev, ...data]);
      }
      
      setHasMore(data.length === PAGE_SIZE);
      return data;
    } catch (err) {
      setError(err);
      setHasMore(false);
    } finally {
      setIsLoading(false);
    }
  }, [issueId]);

  const loadMore = useCallback(() => {
    if (!isLoading && hasMore) {
      fetchDrops(drops.length);
    }
  }, [isLoading, hasMore, drops.length, fetchDrops]);

  return { 
    drops, 
    isLoading, 
    hasMore, 
    error, 
    fetchDrops, 
    loadMore 
  };
};

